import { Link } from '@tanstack/react-router';
import { Button } from '@workspace/ui/components/button';
import { ShieldAlert, X } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '~/auth/use-auth';
import { m } from '~/paraglide/messages.js';

export function KycVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  const isVerified = user?.metadata?.kyc_verified || false;

  if (isVerified || dismissed) return null;

  return (
    <div className="relative mx-4 mt-2 mb-1 overflow-hidden rounded-lg border border-amber-500/20 bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-transparent">
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex shrink-0 items-center justify-center rounded-full bg-amber-500/15 p-2">
          <ShieldAlert className="h-5 w-5 text-amber-500" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{m['kyc_gate.banner_title']()}</p>
          <p className="text-xs text-muted-foreground mt-0.5 hidden sm:block">
            {m['kyc_gate.banner_description']()}
          </p>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Button size="sm" asChild className="h-8">
            <Link to="/verify-identity/kyc">
              {m['kyc_gate.banner_button']()}
            </Link>
          </Button>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="rounded-md p-1 text-muted-foreground/60 hover:text-muted-foreground transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
